import { render, staticRenderFns } from "./Avis.vue?vue&type=template&id=f71a42ce&"
import script from "./Avis.vue?vue&type=script&lang=js&"
export * from "./Avis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports